module.exports = __webpack_public_path__ + "static/img/fengdi.ae23b83d.png";